import { GenericButtonProps, Generic } from './GenericButton';

export function SecondaryButton(props: GenericButtonProps) {
    const bgClass = props.disabled
        ? 'border-theme-outline bg-theme-950/40 text-theme-text/30'
        : 'border-theme-outline bg-button-secondary-1 text-theme-text hover:border-theme-400 hover:bg-button-secondary-2 focus-visible:ring-theme-primary/50';

    return <Generic {...props} className={`${bgClass} ${props.className ?? ''}`} />;
}
